  jQuery(document).ready(function() {

    jQuery('[data-increament]').on('click', function() {
      const container = jQuery(this).closest('.product-quantity--root');
      const input = container.find('input.product-quantity--input');
      let current = parseInt(input.val()) || 1;
      current += 1;
      input.val(current).change();
    });
    
    jQuery('[data-decreament]').on('click', function() {
      const container = jQuery(this).closest('.product-quantity--root');
      const input = container.find('input.product-quantity--input');
      let current = parseInt(input.val()) || 1;
      if (current > 1) {
        current -= 1;
        input.val(current).change();
      }else{
        console.log(`Quantity should be greater then 1`);
      }
    });


   

    // let window_w = jQuery(window).width();
    //   if(window_w < 766){
    //      $(".product-page--block  .radios--container-wrapper").mCustomScrollbar({
    //         axis:"x",
    //         scrollbarPosition: "inside"
    //     });
    //   }else{
    //     $(".product-page--block  .radios--container-wrapper").mCustomScrollbar("destroy");
    //   }

    // jQuery(window).on('resize', function(){
    //    window_w = jQuery(window).width();
    //   if(window_w < 766){
    //     //  $(".product-page--block .radios--container-wrapper").mCustomScrollbar({
    //     //     axis:"x",
    //     //     scrollbarPosition: "inside"
    //     // });
    //   }else{
    //     //$(".product-page--block  .radios--container-wrapper").mCustomScrollbar("destroy");
    //   }
    // });



    // const productOptions = document.querySelectorAll('.product-options--root .radios--main');
    // if(productOptions){
    //   productOptions.forEach(radio => {
    //     radio.addEventListener('click', function () {

    //       setTimeout(function(){
    //            var windoww = jQuery(window).width();
    //           if(windoww < 766){
    //             $(".product-page--block  .radios--container-wrapper").mCustomScrollbar("destroy");
    //              $(".radios--container-wrapper").mCustomScrollbar({
    //                 axis:"x",
    //                 scrollbarPosition: "inside"
    //             });
    //           }
    //       }, 1000);
          
    //     });
    //   });
    // }
    
    // jQuery('.carousel--root-v2').flickity({
    //   wrapAround: true,
    //   pageDots: false,
    //   prevNextButtons: false,
    // });
      
    // // 2nd carousel, navigation
    // $('.product-carousel-thumbnail').flickity({
    //   asNavFor: '.carousel--root-v2',
    //   contain: true,
    //   pageDots: false,
    //   prevNextButtons: false,
    // });
      
  });